import './OfferSearchFilterSidebar.scss'

import {Component} from 'react'
import PropTypes from 'prop-types'
import {Input} from 'reactstrap'
import {
  ChevronDown,
  Compass,
  FileText,
  Filter,
  Globe,
  Key,
  List,
  User,
  X,
} from 'react-feather'

import api from '../../../../../../api.js'
import FilterBool from '../../../../../../shared/components/FilterBar/components/FilterBool/FilterBool.jsx'
import FilterCity from '../../../../../../shared/components/FilterBar/components/FilterCity/FilterCity.jsx'
import FilterDistance from '../../../../../../shared/components/FilterBar/components/FilterDistance/FilterDistance.jsx'
import FilterManager from '../../../../../../shared/components/FilterBar/components/FilterManager/FilterManager.jsx'
import FilterType from '../../../../../../shared/components/FilterBar/components/FilterType/FilterType.jsx'
import SearchInput from '../../../../../components/SearchBar/components/SearchInput/SearchInput.jsx'

import {
  CITY_FILTER_KEY,
  DISTANCE_FILTER_KEY,
  MANAGER_FILTER_KEY,
  MY_APPLICATION_FILTER_KEY,
  RELOCATION_FILTER_KEY,
  TYPE_FILTER_KEY,
  UNIVERSE_FILTER_KEY,
} from '../../../../../../shared/constants/filters.js'

class FilterSection extends Component {
  static propTypes = {
    icon: PropTypes.elementType.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node,
    defaultOpen: PropTypes.bool,
  }

  static defaultProps = {
    defaultOpen: false,
  }

  state = {
    open: this.props.defaultOpen,
  }

  toggle = () => {
    this.setState((prevState) => ({open: !prevState.open}))
  }

  render() {
    const {icon: Icon, title, children} = this.props
    const {open} = this.state

    return (
      <div className="filter-section">
        <button type="button" className="filter-section__title" onClick={this.toggle}>
          <Icon size={22} />
          <span className="filter-section__title-label">{title}</span>
          <ChevronDown size={18} className={`filter-section__chevron${open ? ' filter-section__chevron--open' : ''}`} />
        </button>
        {open && (
          <div className="filter-section__content">
            {children}
          </div>
        )}
      </div>
    )
  }
}

export default class OfferSearchFilterSidebar extends Component {
  static propTypes = {
    currentUniverseId: PropTypes.number,
    filters: PropTypes.object.isRequired,
    isAdmin: PropTypes.bool,
    isCity: PropTypes.shape({all: PropTypes.bool, remote: PropTypes.bool, placeholder: PropTypes.string}),
    isManager: PropTypes.bool,
    isOnlyMy: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    searchQuery: PropTypes.object.isRequired,
    topologies: PropTypes.array,
    userMainUniverseId: PropTypes.number,
  }

  static defaultProps = {
    currentUniverseId: null,
    isAdmin: false,
    isCity: {all: false, remote: false},
    isManager: false,
    isOnlyMy: false,
    topologies: [],
    userMainUniverseId: null,
  }

  state = {
    mobileOpen: false,
    universes: [],
    draft: {},
  }

  componentDidMount() {
    api.universes.getAll()
      .then((response) => {
        if (response.data) {
          this.setState({universes: response.data})
        }
      })
      .catch((error) => console.error({error}))
  }

  toggleMobile = () => {
    this.setState((prevState) => ({mobileOpen: !prevState.mobileOpen}))
  }

  updateDraft = (data) => {
    this.setState((prevState) => ({draft: {...prevState.draft, ...data}}))
  }

  handleSubmit = () => {
    this.props.onChange(this.state.draft)
  }

  computeActiveCount = () => {
    const {isAdmin, isManager, isOnlyMy, searchQuery, topologies} = this.props
    const effective = searchQuery ?? {}
    let count = effective.keywords?.length ?? 0

    if (effective[CITY_FILTER_KEY]) count += 1
    if (effective[RELOCATION_FILTER_KEY] === '1' || effective[RELOCATION_FILTER_KEY] === 1) count += 1
    if (effective[DISTANCE_FILTER_KEY]) count += 1

    if (isAdmin) {
      const type = effective[TYPE_FILTER_KEY] ?? 0
      topologies.forEach((pair) => {
        pair.forEach((item) => {
          if (type & item.value) count += 1
        })
      })
    }

    if (isAdmin && isManager && effective[MANAGER_FILTER_KEY]) count += 1
    if (isOnlyMy && (effective[MY_APPLICATION_FILTER_KEY] === '1' || effective[MY_APPLICATION_FILTER_KEY] === 1)) count += 1

    return count
  }

  getSearchPlaceholder = (effective) => {
    const requirementsSelected = effective?.requirements ? parseInt(effective.requirements, 10) : null

    if (!requirementsSelected) return 'Rechercher une annonce'
    if (requirementsSelected === 1) return 'Rechercher un ID'
    return 'Rechercher ...'
  }

  handleReset = () => {
    const {onChange, searchQuery} = this.props
    const data = searchQuery

    delete data.keywords
    delete data.requirements
    delete data[CITY_FILTER_KEY]
    delete data.latitude
    delete data.longitude
    delete data[RELOCATION_FILTER_KEY]
    delete data[DISTANCE_FILTER_KEY]
    delete data[TYPE_FILTER_KEY]
    delete data[MANAGER_FILTER_KEY]
    delete data[MY_APPLICATION_FILTER_KEY]
    this.props.filters.orders.forEach((item) => {
      delete data[item.name]
    })

    this.setState({mobileOpen: false, draft: {}})
    onChange(data)
  }

  render() {
    const {
      currentUniverseId, filters, isAdmin, isCity, isManager, isOnlyMy,
      searchQuery, topologies, userMainUniverseId,
    } = this.props
    const {mobileOpen, universes, draft} = this.state

    const effective = {...searchQuery, ...draft}
    const selectedUniverse = effective?.[UNIVERSE_FILTER_KEY] ?? (currentUniverseId ?? userMainUniverseId)
    const availableUniversesOptions = universes.map((universe) => ({value: universe.id, text: universe.name}))
    const activeCount = this.computeActiveCount()

    return (
      <div className="offer-search-filter-sidebar">
        <button
          type="button"
          className="offer-search-filter-sidebar__mobile-toggle btn btn-secondary btn-auto-width"
          onClick={this.toggleMobile}
        >
          <Filter size={18} />
          Filtres
          {activeCount > 0 && <span className="offer-search-filter-sidebar__badge">{activeCount}</span>}
        </button>

        {mobileOpen && (
          <div className="offer-search-filter-sidebar__overlay" onClick={this.toggleMobile} />
        )}

        <div className={`offer-search-filter-sidebar__inner${mobileOpen ? ' offer-search-filter-sidebar__inner--open' : ''}`}>
          <div className="offer-search-filter-sidebar__header">
            <h2>Filtres</h2>

            <button type="button" className="btn-reset" onClick={this.handleReset}>
              Réinitialiser
            </button>

            <button
              type="button"
              className="offer-search-filter-sidebar__close btn-auto-width"
              onClick={this.toggleMobile}
            >
              <X size={20} />
            </button>
          </div>

          <div className="offer-search-filter-sidebar__body">
            <FilterSection icon={Key} title="Mots clés" defaultOpen={true}>
              <Input
                type="select"
                value={effective?.requirements ?? ''}
                onChange={(event) => this.updateDraft({requirements: event.target.value === '' ? undefined : parseInt(event.target.value, 10)})}
              >
                {(filters?.requirementChoices?.length ? filters.requirementChoices : []).map((choice) => (
                  <option value={choice.value ?? ''} key={choice.text}>{choice.text}</option>
                ))}
              </Input>

              <div className="offer-search-filter-sidebar__search-input">
                <SearchInput
                  className="input-search"
                  value={effective?.keywords?.length ? effective.keywords : []}
                  onChange={(newVal) => this.updateDraft({keywords: newVal})}
                  placeholder={this.getSearchPlaceholder(effective)}
                />
              </div>
            </FilterSection>

            <FilterSection icon={Globe} title="Univers" defaultOpen={true}>
              <Input
                type="select"
                value={selectedUniverse ?? ''}
                onChange={(event) => this.updateDraft({[UNIVERSE_FILTER_KEY]: parseInt(event.target.value, 10)})}
              >
                {availableUniversesOptions.map((choice) => (
                  <option value={choice.value} key={choice.value}>{choice.text}</option>
                ))}
              </Input>
            </FilterSection>

            {isAdmin && topologies?.length > 0 && (
              <FilterSection icon={List} title="Topologie" defaultOpen={true}>
                <div className="offer-search-filter-sidebar__topology">
                  <FilterType
                    topologies={topologies}
                    type={effective?.type ?? 0}
                    onChange={(data) => this.updateDraft({type: data})}
                  />
                </div>
              </FilterSection>
            )}

            {isAdmin && isManager && (
              <FilterSection icon={User} title="Responsable">
                <FilterManager
                  value={effective?.manager}
                  onChange={(data) => this.updateDraft(data)}
                />
              </FilterSection>
            )}

            {isCity?.all && (
              <FilterSection icon={Compass} title="Localisation">
                <FilterDistance
                  distance={effective?.[DISTANCE_FILTER_KEY]}
                  onChange={(data = {}) => this.updateDraft(data)}
                />
                <FilterCity
                  city={effective?.city ?? null}
                  relocation={effective?.[RELOCATION_FILTER_KEY] === '1'}
                  onChange={(data = {}) => this.updateDraft(data)}
                  onChecked={(data) => this.updateDraft({relocation: data ? 1 : 0})}
                  isRemote={isCity.remote}
                  placeholder={`${effective?.[DISTANCE_FILTER_KEY] ?? '40'}km autour de ...`}
                />
              </FilterSection>
            )}

            {isOnlyMy && (
              <FilterSection icon={FileText} title="Mes candidatures">
                <FilterBool
                  value={true}
                  label="Offres de mission où j'ai postulé"
                  onChange={(data) => this.updateDraft({[MY_APPLICATION_FILTER_KEY]: data === true ? 1 : 0})}
                />
              </FilterSection>
            )}
          </div>

          <div className="offer-search-filter-sidebar__footer">
            <button type="button" className="btn btn-secondary" onClick={this.handleSubmit}>
              Filtrer
            </button>
          </div>
        </div>
      </div>
    )
  }
}
